/* TestRuleComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./TestRuleRenderer");

class TestRuleComponent extends EventEmitter {
    constructor(logger, userSession, editRuleForm, modalUserFeedback, parentRenderer) {
        super();
        this._titleText = "Test Rule";
        this._logger = logger;
        this._userSession = userSession;
        this._editRuleForm = editRuleForm;
        this._currentFilterExpression = {};
        // this._formData = FormData;
        this._policyName = this._editRuleForm.name || "";
        this._modalUserFeedback = modalUserFeedback;
        this._parentRenderer = parentRenderer;

        this._userDataStorage = this._parentRenderer._model._userDataStorage;

        const rules = this._parentRenderer._model._parentView._auditPolicy.getRules() || [];
        this._notSaved = false;
        if (
            this._policyName === "New rule" &&
            rules.filter((rule) => rule.name === "New rule").length > 1
        ) {
            this._notSaved = true;
        }

        this._renderer = new Renderer(this);

        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);
        this._workInput = {};

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "CaptureNameComponent.shutdown() error");
            }
        );
    }

    _setUserData(deviceProps) {
        if (!this._notSaved) {
            const data = {
                configLines: this._renderer._testDataRegExComponent.getValue() || "",
                deviceProps,
            };

            this._userDataStorage.setData(data, "test_rule_data_" + this._policyName);
        }
    }

    _getUserData() {
        if (!this._notSaved) {
            return this._userDataStorage.getData("test_rule_data_" + this._policyName, true) || {};
        }
        return {};
    }

    updateWorkInput() {
        let deviceProps = this._getDevicePropsFromField();

        if (deviceProps) {
            this._setUserData(deviceProps);
        }

        if (deviceProps) {
            this._workInput = {
                expression: this._currentFilterExpression,
                configLines: this._renderer._testDataRegExComponent.getValue() || "",
                os: _.get(this._editRuleForm, "sourceQuery.os", undefined),
                conceptItemId: _.get(this._editRuleForm, "sourceQuery.conceptItemId", undefined),
                rsiId: _.get(this._editRuleForm, "sourceQuery.rsiId", undefined),
                scope: _.get(this._editRuleForm, "sourceQuery.query", ""),
                scopeSeparateResults: _.get(this._editRuleForm, "sourceQuery.individual", false),
                deviceProps,
            };
            if (this._workInput.conceptItemId === "0") {
                this._workInput.conceptItemId = undefined;
            }
            this._formInvalid = false;
        } else {
            this._formInvalid = true;
            this.emit("Error", "Invalid Device Properties JSON");
        }
    }

    _getDevicePropsFromField() {
        const devicecPropValue = this._renderer._DevicePropertiesRegExComponent.getValue();
        let deviceProps = devicecPropValue
            .replace(/\n/g, "")
            .replace(/ /g, "")
            .replace(/(\w+:)|(\w+ :)/g, function (matchedStr) {
                return '"' + matchedStr.substring(0, matchedStr.length - 1) + '":';
            });
        deviceProps = this.getObjectFromString(deviceProps);
        return deviceProps;
    }

    getObjectFromString(str) {
        try {
            const val = JSON.parse(str);
            return val;
        } catch (err) {
            return false;
        }
    }

    _runTest() {
        if (!this._formInvalid) {
            const progressFunc = (workResult) => {
                console.log(workResult);
            };
            this._parentRenderer._model._parentView._auditPolicy
                .runTestAuditRuleWork(this._workInput, {launchAndForget: false}, progressFunc)
                .then((res) => {
                    if (res.summary.errorMsg) {
                        this.emit("Error", res.summary.errorMsg);
                    } else {
                        this.emit("Results", res);
                    }
                });
        }
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }
    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = TestRuleComponent;
